import React, { Component } from 'react'
import '../../Tablet/ContactUs/ContactUs.css';
import '../../Tablet/ContactUs/ContactUs.css';
import './form.css';


export default class CostEstimate extends Component {
    render() {
        return (
                <>
                    <div style={{marginTop:"20px"}} className="container">
                        <form >
                            <div className="f-row">
                                <div className="f-column-12 mb-1">
                                    <input className="cost-style" type="text" id="fname" name="city" placeholder="City"/>
                                </div>
                            </div>
                            <div class="f-row" style={{marginTop:'15px'}}>
                                <div className="f-column-12">
                                    <input className="cost-style" type="text" id="lname" name="area" placeholder="Area Of Construction(Sq.ft)"/>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
        )
    }
}
